module.exports = __webpack_public_path__ + "fonts/sourcesansproextralightitalic.ccd35985.woff";